import "./style.scss";
import * as React from "react";
import { CHART_COLORS } from "../../common";

const RADIAN = Math.PI / 180;

const determineTextAnchor = (x: number, cx: number) => {
  if (x > cx + 25) return "start";
  else if (x < cx - 25) return "end";
  else return "middle";
};

const determineTextOffset = (y: number, cy: number) => {
  if (y > cy + 50) return 10;
  return 0;
};

// These are passed automatically by ReCharts Pie Component
interface PercentLabelProps {
  cx?: number;
  cy?: number;
  midAngle?: number;
  innerRadius?: number;
  outerRadius?: number;
  percent?: number;
  index?: number;
}

export const PercentLabel = (props: PercentLabelProps) => {
  const { cx, cy, percent, innerRadius, outerRadius, midAngle, index } = props;
  const radius = innerRadius + (outerRadius - innerRadius) + 25;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  const anchor = determineTextAnchor(x, cx);
  const dy = determineTextOffset(y, cy);

  const color = `#${CHART_COLORS[index % CHART_COLORS.length].toString(16)}`; // <text fill={color}/>
  const formatedPercent = percent.toLocaleString("en-IN", {
    style: "percent",
    maximumFractionDigits: 0
  });
  return (
    <text className="pie-label" x={x} y={y} dy={dy} textAnchor={anchor}>
      {formatedPercent}
    </text>
  );
};



// WEBPACK FOOTER //
// ./client/modules/core/Chart/RadialChart/PercentLabel/index.tsx